"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelDetailsClient = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _eventEmitter = _interopRequireDefault(require("event-emitter"));
var _allOff = _interopRequireDefault(require("event-emitter/all-off"));
var _http = require("../services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _constants = require("../constants");
var _hotelDetails = require("../utils/hotel-details.utils");
var _excluded = ["hotelId"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HotelDetailsClient = exports.HotelDetailsClient = {
  /**
   * get hotel info
   *
   * @param {number} hotelId
   * @param {number=} timeout in ms
   * @returns {Promise}
   */
  getHotelInfo: function getHotelInfo(_ref) {
    var hotelId = _ref.hotelId,
      timeout = _ref.timeout;
    var requestId = "HOTEL_INFO_".concat(hotelId);
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTEL_INFO, {
      hotelId: hotelId
    });
    return _http.$http.get(requestId, endPoint, {
      timeout: timeout
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  },
  /**
   * get hotel trust you reviews
   *
   * @param {number} hotelId
   * @param {number=} timeout in ms
   * @returns {Promise}
   */
  getTrustYouReviews: function getTrustYouReviews(_ref3) {
    var hotelId = _ref3.hotelId,
      timeout = _ref3.timeout;
    var requestId = "HOTEL_REVIEWS_".concat(hotelId);
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTEL_REVIEWS, {
      hotelId: hotelId
    });
    return _http.$http.get(requestId, endPoint, {
      timeout: timeout
    }).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  },
  /**
   * get packages
   *
   * @param {Object} payload [required]
   * @param {String} payload.sId [required]
   * @param {{ hotelId: Number }} payload.packagesRequest [required]
   * @param {String=} pId
   * @param {Function=} onPollingCancel
   * @returns {EventEmitter}
   */
  getPackages: function getPackages(_ref5) {
    var _this = this;
    var payload = _ref5.payload,
      pId = _ref5.pId,
      onPollingCancel = _ref5.onPollingCancel;
    if (this.packagesEventEmitter) {
      (0, _allOff["default"])(this.packagesEventEmitter);
    }
    this.packagesEventEmitter = (0, _eventEmitter["default"])();
    if (pId) {
      this.pollPackages(pId, onPollingCancel);
      return this.packagesEventEmitter;
    }
    this.generatePackagesPollingId(payload).then(function (_ref6) {
      var pId = _ref6.pId;
      return _this.pollPackages(pId, onPollingCancel);
    })["catch"](function (error) {
      _this.packagesEventEmitter.emit('pollingIdGenerationError', error);
      _this.packagesEventEmitter.emit('end');
    });
    return this.packagesEventEmitter;
  },
  /**
   * generate polling id [pId]
   *
   * @param {String} payload.sId [required]
   * @param {{ hotelId: Number }} payload.packagesRequest [required]
   * @returns {Promise}
   */
  generatePackagesPollingId: function generatePackagesPollingId(payload) {
    var requestId = 'GENERATE_PACKAGES_POLLING_ID';
    var endPoint = _constants.ENDPOINTS.GENERATE_PACKAGES_POLLING_ID;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref7) {
      var data = _ref7.data;
      return data;
    });
  },
  /**
   * modify search for get packages
   *
   * @param {Object} payload [required]
   * @param {String} payload.checkIn [required]
   * @param {String} payload.checkOut [required]
   * @param {Array<{adultsCount: Number, kidsAges: Array<Number>}>} payload.roomsInfo [required]
   * @param {String} payload.hotelId [required]
   * @param {String=} pId
   * @param {Function=} onPollingCancel
   * @returns {EventEmitter}
   */
  modifyGetPackagesSearch: function modifyGetPackagesSearch(_ref8) {
    var _this2 = this;
    var payload = _ref8.payload,
      pId = _ref8.pId,
      updatePackagesId = _ref8.updatePackagesId,
      onPollingCancel = _ref8.onPollingCancel;
    if (this.packagesEventEmitter) {
      (0, _allOff["default"])(this.packagesEventEmitter);
    }
    this.packagesEventEmitter = (0, _eventEmitter["default"])();
    if (pId) {
      this.pollPackages(pId, onPollingCancel);
      return this.packagesEventEmitter;
    }
    this.generateModifySearchPollingId(payload).then(function (_ref9) {
      var pId = _ref9.pId,
        sId = _ref9.sId;
      updatePackagesId(pId, sId);
      _this2.pollPackages(pId, onPollingCancel);
    })["catch"](function (error) {
      _this2.packagesEventEmitter.emit('pollingIdGenerationError', error);
      _this2.packagesEventEmitter.emit('end');
    });
    return this.packagesEventEmitter;
  },
  /**
   * generate modify search polling id [pId]
   *
   * @description
   * you can generate the polling id by `query` or `hotelId` or `placeId` or `geoCoordinates`
   *
   * @param {String} payload.checkIn [required]
   * @param {String} payload.checkOut [required]
   * @param {Array<{adultsCount: Number, kidsAges: Array<Number>}>} payload.roomsInfo [required]
   * @param {String} payload.hotelId [required]
   * @returns {Promise}
   */
  generateModifySearchPollingId: function generateModifySearchPollingId(payload) {
    var _payload$roomsInfo, _payload$roomsInfo2;
    var requestId = 'GENERATE_MODIFY_SEARCH_POLLING_ID';
    var endPoint = _constants.ENDPOINTS.GENERATE_MODIFY_SEARCH_POLLING_ID;
    var data = _objectSpread({}, payload);
    if ((payload === null || payload === void 0 ? void 0 : (_payload$roomsInfo = payload.roomsInfo) === null || _payload$roomsInfo === void 0 ? void 0 : _payload$roomsInfo.length) === 2 && payload !== null && payload !== void 0 && payload.isMultiResponse) {
      data = _objectSpread(_objectSpread({}, data), {}, {
        variant: 'multi_room'
      });
    }
    if ((payload === null || payload === void 0 ? void 0 : (_payload$roomsInfo2 = payload.roomsInfo) === null || _payload$roomsInfo2 === void 0 ? void 0 : _payload$roomsInfo2.length) === 1) {
      data = _objectSpread(_objectSpread({}, data), {}, {
        variant: 'MULTI_SEARCH_SPLIT'
      });
    }
    var headers = {};
    if (payload !== null && payload !== void 0 && payload.priceCalendar && payload !== null && payload !== void 0 && payload.priceCalendarId) {
      headers['x-flow-source'] = payload === null || payload === void 0 ? void 0 : payload.priceCalendar;
      headers['x-flow-source-id'] = payload === null || payload === void 0 ? void 0 : payload.priceCalendarId;
    }
    return _http.$http.put(requestId, endPoint, {
      data: (0, _omit2["default"])(data, ['isMultiResponse']),
      headers: headers
    }).then(function (_ref10) {
      var data = _ref10.data;
      return data;
    });
  },
  /**
   * poll packages
   * @param {String} pId
   * @param {Function=} onPollingCancel
   * @returns {Promise}
   */
  pollPackages: function pollPackages(pId) {
    var _arguments = arguments,
      _this3 = this;
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var onPollingCancel, endPoint, IN_PROGRESS, searchStatus, hasPollingError, requestId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onPollingCancel = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : function () {};
            endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.GET_PACKAGES, {
              pId: pId
            });
            IN_PROGRESS = _constants.SEARCH_POLLING_RESPONSE_STATUS.IN_PROGRESS;
            searchStatus = IN_PROGRESS;
            hasPollingError = false;
            _context.prev = 5;
          case 6:
            if (!(!hasPollingError && searchStatus === IN_PROGRESS)) {
              _context.next = 13;
              break;
            }
            requestId = "GET_PACKAGES_".concat(Date.now());
            _http.$http.get(requestId, endPoint).then(function (_ref11) {
              var data = _ref11.data;
              searchStatus === IN_PROGRESS && _this3.packagesEventEmitter.emit('data', data);
              searchStatus = data.pollingStatus;
            })["catch"](function (error) {
              hasPollingError = true;
              if (_http.$http.isCancellationError(error)) {
                onPollingCancel();
              } else {
                _this3.packagesEventEmitter.emit('error', error);
              }
            });
            _context.next = 11;
            return new Promise(function (resolve) {
              return setTimeout(resolve, _constants.PACKAGES_POLLING_INTERVAL_IN_MILLI_SECONDS);
            });
          case 11:
            _context.next = 6;
            break;
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            _this3.packagesEventEmitter.emit('error', _context.t0);
          case 18:
            _context.prev = 18;
            _this3.packagesEventEmitter.emit('end');
            return _context.finish(18);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 15, 18, 21]]);
    }))();
  },
  /**
   * get rooms templates
   * @param {Array<String>} templateIds
   * @return {Promise}
   */
  getRoomsTemplates: function getRoomsTemplates(_ref12) {
    var templateIds = _ref12.templateIds,
      atgHotelId = _ref12.atgHotelId;
    var requestId = "GET_ROOMS_TEMPLATES";
    var endPoint = "".concat((0, _client.replaceParams)(_constants.ENDPOINTS.GET_ROOMS_TEMPLATES, {
      templateIds: templateIds
    }), "?atgHotelId=").concat(atgHotelId);
    return _http.$http.get(requestId, endPoint).then(function (_ref13) {
      var data = _ref13.data;
      return data;
    });
  },
  getStaticSimilarHotels: function getStaticSimilarHotels(_ref14) {
    var payload = _ref14.payload;
    var hotelId = payload.hotelId;
    var requestId = "STATIC_SIMILAR_HOTELS_".concat(hotelId);
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.SIMILAR_HOTELS_STATIC_CONTENT, {
      hotelId: hotelId
    });
    return _http.$http.get(requestId, endPoint).then(function (_ref15) {
      var data = _ref15.data;
      return data;
    });
  },
  getDynamicSimilarHotels: function getDynamicSimilarHotels(_ref16) {
    var payload = _ref16.payload;
    var hotelsId = Object.keys(payload.hotels).filter(function (id) {
      return id !== String(payload.currentHotelId);
    });
    var requestId = "DYNAMIC_SIMILAR_HOTELS_".concat(hotelsId);
    var endPoint = _constants.ENDPOINTS.SIMILAR_HOTELS_DYNAMIC_CONTENT;
    return _http.$http.post(requestId, endPoint, {
      data: {
        hotelsId: hotelsId
      }
    }).then(function (_ref17) {
      var searchResults = _ref17.data.searchResults;
      return (0, _hotelDetails.formatDynamicContent)({
        searchResults: searchResults,
        payload: payload
      });
    });
  },
  /**
   * get similar hotels
   *
   * @param {Object} payload [required]
   * @param {String} payload.checkIn [required]
   * @param {String} payload.checkOut [required]
   * @param {Array<{adultsCount: Number, kidsAges: Array<Number>}>} payload.roomsInfo [required]
   * @param {String} payload.hotelId [required]
   * @return {Promise}
   */
  getSimilarHotels: function getSimilarHotels(_ref18) {
    var payload = _ref18.payload;
    var hotelId = payload.hotelId,
      dynamicContentPayload = (0, _objectWithoutProperties2["default"])(payload, _excluded);
    var requestId = "SIMILAR_HOTELS_".concat(hotelId);
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.SIMILAR_HOTELS_STATIC_CONTENT, {
      hotelId: hotelId
    });
    return _http.$http.get(requestId, endPoint).then(function (_ref19) {
      var data = _ref19.data;
      var staticHotels = data;
      var hotelsId = (0, _keys2["default"])((0, _get2["default"])(data, 'hotels'));
      var requestId = "SIMILAR_HOTELS_DYNAMIC_CONTENT_".concat(hotelsId);
      var endPoint = _constants.ENDPOINTS.SIMILAR_HOTELS_DYNAMIC_CONTENT;
      return _http.$http.post(requestId, endPoint, {
        data: _objectSpread(_objectSpread({}, dynamicContentPayload), {}, {
          hotelsId: hotelsId
        })
      }).then(function (_ref20) {
        var data = _ref20.data;
        return (0, _map2["default"])(data.searchResults, function (dynamicContent) {
          return {
            hotelId: (0, _get2["default"])(dynamicContent, 'hotelId'),
            dynamicContent: dynamicContent,
            staticContent: (0, _get2["default"])(staticHotels, "hotels.".concat((0, _get2["default"])(dynamicContent, 'hotelId')))
          };
        });
      });
    });
  },
  /**
   * get ATG hotel id  by TV hotel id
   * @param {Number} tvHotelId
   * TODO: remove this commented code after live testing is completed with all the scenarios
   */
  // getAtgHotelIdByTvHotelId(tvHotelId) {
  //   const requestId = `GET_ATG_HOTEL_ID`;
  //   const endPoint = replaceParams(ENDPOINTS.GET_ATG_HOTEL_ID, { tvHotelId });
  //
  //   return $http.get(requestId, endPoint).then(({ data }) => data);
  // },
  /**
   * get Almosafer Hotel Reviews
   * @return {Promise}
   */
  getAlmosaferHotelReviews: function getAlmosaferHotelReviews(_ref21) {
    var atgHotelId = _ref21.atgHotelId;
    var requestId = 'GET_ALMOSAFER_HOTEL_REVIEWS';
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.ALMOSAFER_REVIEWS, {
      atgHotelId: atgHotelId
    });
    return _http.$http.get(requestId, endPoint, {
      transformRequest: [function (data, headers) {
        delete headers.common.Authorization;
        delete headers.common.token;
        return data;
      }]
    }).then(function (_ref22) {
      var data = _ref22.data;
      return data;
    });
  }
};